import React from 'react';

import { FORM_ERROR } from 'final-form';
import isNil from 'lodash/isNil';

import WizardForm from '@qality/common-components/src/molecules/final-form/WizardForm';
import { StorageOfUniqueServices } from '@qality/common-service';

import { useAddTestCasesContext } from '../../lib/AddTestCasesProvider/AddTestCasesContext';
import {
  AddTestCasesFormPageContainerStyled,
  AddTestCasesStepStyled,
} from './AddTestCasesForm.styled';
import { SelectCycle } from './steps/SelectCycle/SelectCycle';
import { SelectCycleValidator } from './steps/SelectCycle/SelectCycle.validation';
import { SelectIssues, selectIssuesValidator } from './steps/SelectIssues';
import { AddTestCasesFormValues } from './types';

export interface AddTestCasesFormViewProps {
  initialValues: AddTestCasesFormValues;
}

export const AddTestCasesFormView: React.FC<AddTestCasesFormViewProps> = ({
  initialValues,
}: AddTestCasesFormViewProps) => {
  const {
    addTestCasesToTestCycle,
    isAddingTestCases,
    availableIssues,
    isFetchingIssues,
    returnURL,
  } = useAddTestCasesContext();

  const handleCancel = () => {
    StorageOfUniqueServices.get('AP').navigator.go('site', {
      absoluteUrl: returnURL,
    });
  };

  const handleSubmitForm = async (values) => {
    const { testCycle, issues } = values;
    const selectedIssuesIds = issues
      .map((issue) => {
        return issue.isChecked && issue.id;
      })
      .filter(Boolean);

    const testCycleURL = StorageOfUniqueServices.get(
      'URLService'
    ).getTestCycleUrl(testCycle.value, selectedIssuesIds.length);

    const response = await addTestCasesToTestCycle(
      selectedIssuesIds,
      testCycle.value
    );

    if (!isNil(response)) {
      StorageOfUniqueServices.get('AP').navigator.go('site', {
        absoluteUrl: testCycleURL,
      });
    } else {
      return { [FORM_ERROR]: 'Adding Test Cases unsuccessfull' };
    }
  };

  return (
    <AddTestCasesFormPageContainerStyled>
      <WizardForm
        header='Add Test Cases to Test Cycle'
        initialValues={{
          ...initialValues,
        }}
      >
        <WizardForm.Page
          label='Select Cycle'
          onCancel={handleCancel}
          validate={SelectCycleValidator}
          showNavigation={!isFetchingIssues && availableIssues.length > 0}
        >
          <AddTestCasesStepStyled>
            <SelectCycle onCancel={handleCancel} />
          </AddTestCasesStepStyled>
        </WizardForm.Page>
        <WizardForm.Page
          label='Select Issues'
          nextWording='Add to Test Cycle'
          onCancel={handleCancel}
          fillPageArea
          validate={selectIssuesValidator}
          onSubmit={handleSubmitForm}
          showNavigation={!isAddingTestCases}
        >
          <AddTestCasesStepStyled>
            <SelectIssues />
          </AddTestCasesStepStyled>
        </WizardForm.Page>
      </WizardForm>
    </AddTestCasesFormPageContainerStyled>
  );
};
